{
  "version": 1,
  "asset_id": "149480d6-6c55-490c-8dc6-6b5b7bb7d6d6",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/149480d6-6c55-490c-8dc6-6b5b7bb7d6d6/hernando-galvalume-metal-roof-destination-roofing-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/149480d6-6c55-490c-8dc6-6b5b7bb7d6d6/hernando-galvalume-metal-roof-destination-roofing-1320w.webp",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-1320w.webp",
  "size": 226976,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
